<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>{{currentPage}}</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div *ngIf="selecte_documentView">
          <div class="row com-doc-head eip-mt-20">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 ml-3 ">
                  <mat-button-toggle-group aria-label="Document Type" class="" [value]='docType' (change)="onDocTypeChange($event.value)">
                      <mat-button-toggle value="RD">Repository Document</mat-button-toggle>
                      <mat-button-toggle value="SD">Workflow Document</mat-button-toggle>
                  </mat-button-toggle-group>
              </div>
          </div>
          <div *ngIf="docType == 'RD' ">
              <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-3 pr-3">
                      <kendo-grid [kendoGridBinding]="gridView" [resizable]="true" [selectable]="true" kendoGridSelectBy="itemIndex" [pageSize]="15" [pageable]="true" (selectionChange)="onSelectionChangeRD($event)" [sortable]="true" [reorderable]="true" [skip]="skip" [resizable]="true" [style.maxHeight]="650" [height]="540">
                          <ng-template kendoPagerTemplate>
                              <div class="k-pager-left">
                                  <kendo-pager-info></kendo-pager-info>
                              </div>
                              <div class="k-pager-right">
                                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                  <kendo-pager-input></kendo-pager-input>
                                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
                              </div>
                          </ng-template>
                          <ng-template kendoGridToolbarTemplate>
                              <div class="k-grid-toolbar-content d-flex">
                                  <div class="flex-grow-1 title-container">
                                      <input placeholder="Search in all repository documents..." style="width: 100%;margin-top: 1%;" kendoTextBox (input)="onFilterRD($event.target.value)" />
                                  </div>
                                  <div class="pagination-container">
                                      <p id="lblShowDetails">Show</p>
                                      <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                                      </kendo-pager-page-sizes>
                                      <span>Items</span>
                                  </div>
                              </div>
                          </ng-template>
                          <kendo-grid-checkbox-column [width]="45" [headerClass]="{'text-center': true}" [class]="{'text-center': true}" [resizable]="false" [columnMenu]="false" showSelectAll="true" (change)="selectedRow()">
                          </kendo-grid-checkbox-column>
                          <kendo-grid-column field="documentNo" title="Document No" [width]="150">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.documentNo}}" eipTooltipPosition="auto">{{dataItem.documentNo}}</span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column field="title" title="Title" [width]="200">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.title}}" eipTooltipPosition="auto">{{dataItem.title}}</span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column field="revision" title="Revision" [width]="50">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.revision}}" eipTooltipPosition="auto">{{dataItem.revision}}</span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column field="createdByName" title="Created By" [width]="150">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.createdByName}}" eipTooltipPosition="auto">{{dataItem.createdByName}}</span>
                              </ng-template>
                          </kendo-grid-column>
                      </kendo-grid>
                  </div>
              </div>
          </div>
          <div *ngIf="docType == 'SD' ">
              <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-3 pr-3">
                      <kendo-grid [kendoGridBinding]="gridView" [selectable]="true" kendoGridSelectBy="itemIndex" [pageSize]="15" [pageable]="true" (selectionChange)="onSelectionChangeSD($event)" [sortable]="true" [reorderable]="true" [resizable]="true" [style.maxHeight]="650" [height]="540">
                          <ng-template kendoPagerTemplate>
                              <div class="k-pager-left">
                                  <kendo-pager-info></kendo-pager-info>
                              </div>
                              <div class="k-pager-right">
                                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                  <kendo-pager-input></kendo-pager-input>
                                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
                              </div>
                          </ng-template>
                          <ng-template kendoGridToolbarTemplate>
                              <div class="k-grid-toolbar-content d-flex">
                                  <div class="flex-grow-1 title-container">
                                      <input placeholder="Search in all workflow documents..." style="width: 100%;margin-top: 1%;" kendoTextBox (input)="onFilterSD($event.target.value)" />
                                  </div>
                                  <div class="pagination-container">
                                      <p id="lblShowDetails">Show</p>
                                      <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                                      </kendo-pager-page-sizes>
                                      <span>Items</span>
                                  </div>
                              </div>
                          </ng-template>
                          <kendo-grid-checkbox-column [width]="45" [headerClass]="{'text-center': true}" [class]="{'text-center': true}" [resizable]="false" [columnMenu]="false" showSelectAll="true" (change)="selectedRow()">
                          </kendo-grid-checkbox-column>
                          <kendo-grid-column field="documentNo" title="Document Number" [width]="150">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.documentNo}}" eipTooltipPosition="auto">{{dataItem.documentNo}}</span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column field="title" title="Title" [width]="200">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.title}}" eipTooltipPosition="auto">{{dataItem.title}}</span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column field="revision" title="Revision" [width]="50">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.revision}}" eipTooltipPosition="auto">{{dataItem.revision}}</span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column field="createdBy" title="Created By" [width]="150">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.createdBy}}" eipTooltipPosition="auto">{{dataItem.createdBy}}</span>
                              </ng-template>
                          </kendo-grid-column>
                      </kendo-grid>
                  </div>
              </div>
          </div>
      </div>
      <div *ngIf="selecte_documentView == false">
          <div class="row com-doc-head eip-mt-20">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 ml-3 ">
              </div>
          </div>
          <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-3 pr-3">
                  <kendo-grid [kendoGridBinding]="gridView1" kendoGridSelectBy="messageId" [pageSize]="15" [pageable]="true" (selectionChange)="onSelectionChangeMSG($event)" [sortable]="true" [reorderable]="true" [resizable]="true" [style.maxHeight]="650" [height]="540">
                      <ng-template kendoPagerTemplate>
                          <div class="k-pager-left">
                              <kendo-pager-info></kendo-pager-info>
                          </div>
                          <div class="k-pager-right">
                              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                              <kendo-pager-input></kendo-pager-input>
                              <kendo-pager-next-buttons></kendo-pager-next-buttons>
                          </div>
                      </ng-template>
                      <ng-template kendoGridToolbarTemplate>
                          <div class="k-grid-toolbar-content d-flex">
                              <div class="flex-grow-1 title-container">
                                  <input placeholder="Search in all messages..." style="width: 100%;  margin-top: 1%;" kendoTextBox (input)="onFilterMSG($event.target.value)" />
                              </div>
                              <div class="pagination-container">
                                  <p id="lblShowDetails">Show</p>
                                  <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                                  </kendo-pager-page-sizes>
                                  <span>Items</span>
                              </div>
                          </div>
                      </ng-template>
                      <kendo-grid-checkbox-column [width]="45" [headerClass]="{'text-center': true}" [class]="{'text-center': true}" [resizable]="false" [columnMenu]="false" showSelectAll="true" (change)="selectedRow()">
                      </kendo-grid-checkbox-column>
                      <kendo-grid-column field="messageNumber" title="Message No" [width]="150">
                          <ng-template kendoGridCellTemplate let-dataItem>
                              <span class="no-wrap" eipTooltip="{{dataItem.messageNumber}}" eipTooltipPosition="auto">{{dataItem.messageNumber}}</span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="messageSubject" title="Subject" [width]="200">
                          <ng-template kendoGridCellTemplate let-dataItem>
                              <span class="no-wrap" eipTooltip="{{dataItem.messageSubject}}" eipTooltipPosition="auto">{{dataItem.messageSubject}}</span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="from" title="From" [width]="50">
                          <ng-template kendoGridCellTemplate let-dataItem>
                              <span class="no-wrap" eipTooltip="{{dataItem.from}}" eipTooltipPosition="auto">{{dataItem.from}}</span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="messageTypeDesc" title="Message Type" [width]="150">
                          <ng-template kendoGridCellTemplate let-dataItem>
                              <span class="no-wrap" eipTooltip="{{dataItem.messageTypeDesc}}" eipTooltipPosition="auto">{{dataItem.messageTypeDesc}}</span>
                          </ng-template>
                      </kendo-grid-column>
                  </kendo-grid>
              </div>
          </div>
      </div>
  </div>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button class="btn btn-primary mt-2 " style="float:right;margin-right: 14px;" (click)="postData()"><i class="fa fa-selection" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Select</button>
  </div>
</div>